import React, { useMemo } from 'react';

import {
  MedalSolidIcon,
  PennantSolidIcon,
  TagsSolidIcon
} from '../../shared/icons/icons';
import Flag from '../flag/flag';

import { isArrayWithLength } from '../../shared/utils/validators/validators';

import { BundleData, ProductData } from '../../shared/types/graphql-types';

import './product-flags.scss';

interface FlaggedProduct {
  hasPromo?: boolean;
  isExclusive?: boolean;
  isFeatured?: boolean;
}

interface ProductFlagsProps {
  className?: string;
  prebuiltPackage?: BundleData;
  product?: ProductData;
}

function ProductFlags(props: ProductFlagsProps) {
  const { className = '', prebuiltPackage, product } = props;
  const { product1, product2 } = prebuiltPackage || {};

  const { hasPromo, isExclusive, isFeatured } = useMemo(
    () =>
      [product, product1, product2].reduce(
        (flaggedProduct: FlaggedProduct, currentProduct): FlaggedProduct => {
          const { isCoreProduct, isExclusive, potentialPromotions } =
            currentProduct || {};
          const hasPromo = isArrayWithLength(potentialPromotions);
          return {
            hasPromo: flaggedProduct.hasPromo || hasPromo,
            isExclusive: Boolean(flaggedProduct.isExclusive || isExclusive),
            isFeatured: Boolean(flaggedProduct.isFeatured || isCoreProduct)
          };
        },
        {
          hasPromo: false,
          isExclusive: false,
          isFeatured: false
        }
      ),
    [product, product1, product2]
  );

  const isFeaturedOrExclusive = isFeatured || isExclusive;

  return isFeaturedOrExclusive || hasPromo ? (
    <span className={className} styleName="container">
      {isFeaturedOrExclusive && (
        <Flag
          renderIcon={
            isFeatured ? (
              <PennantSolidIcon styleName="featured-flag-icon" />
            ) : (
              <MedalSolidIcon styleName="exclusive-flag-icon" />
            )
          }
          styleName={isFeatured ? 'featured-flag' : 'exclusive-flag'}
        >
          {isFeatured ? 'Featured' : 'Exclusive'}
        </Flag>
      )}
      {hasPromo && (
        <Flag
          renderIcon={<TagsSolidIcon styleName="savings-flag-icon" />}
          styleName="savings-flag"
        >
          Savings
        </Flag>
      )}
    </span>
  ) : null;
}

export default ProductFlags;
